import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import axios from 'axios';
// import { getCookie } from '@/utils'
export const exportImportMethods = {
  methods: {
    // 通用数据导出方法
    exportData(data, defaultFileName, sheetName, successMessage) {
      // 检查数据是否有效
      if (!data || !Array.isArray(data) || data.length === 0) {
        this.$message.warning(`${sheetName}为空，无法导出`);
        return;
      }
      
      // 过滤掉无效数据（null、undefined 或空对象）
      const validData = data.filter(row => {
        if (row === null || row === undefined) return false;
        if (typeof row !== 'object') return false;
        return Object.keys(row).length > 0;
      });
      
      if (validData.length === 0) {
        this.$message.warning(`${sheetName}没有有效数据，无法导出`);
        return;
      }
      
      // 确保工作表名称不超过31个字符（Excel标准限制）
      const maxSheetNameLength = 31;
      const safeSheetName = sheetName.length > maxSheetNameLength 
        ? sheetName.substring(0, maxSheetNameLength) 
        : sheetName;
      
      // 创建工作簿
      const workbook = XLSX.utils.book_new();
      
      // 创建工作表数据，使用formatColumnName获取列名
      const headers = {};
      Object.keys(data[0]).forEach(key => {
        headers[key] = this.formatColumnName(key) || key;
      });
      
      // 创建工作表
      const worksheet = XLSX.utils.json_to_sheet(data, {
        header: Object.keys(headers)
      });
      
      // 重命名列头
      XLSX.utils.sheet_add_aoa(worksheet, [Object.values(headers)], { origin: "A1" });
      
      // 将工作表添加到工作簿（使用安全的工作表名称）
      XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName);
      
      // 检查是否在NW.js环境中运行
      try {
        // 安全地访问window对象中的nw
        if (typeof window !== 'undefined' && window.nw && window.nw.Dialog) {
          const dialog = window.nw.Dialog;
          dialog.save({
            title: `保存${sheetName}`,
            defaultPath: `${defaultFileName}.xlsx`,
            filters: [
              { name: 'Excel文件', extensions: ['xlsx'] }
            ]
          }, (filePath) => {
            if (filePath) {
              XLSX.writeFile(workbook, filePath);
              this.$message.success(successMessage);
            }
          });
          return;
        }
      } catch (e) {
        console.error('NW.js对话框错误:', e);
      }
      
      // 备用方案：使用file-saver下载文件
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, `${defaultFileName}.xlsx`);
      this.$message.success(successMessage);
    },
    
    // 生成导出文件名
    generateExportFileName(prefix, formData, professionalRows, excludedColumns = [], specialFields = []) {
      // 收集formData中需要的字段值
      const formDataFields = [];
      let specialValues = [];
      
      // 遍历formData中的所有字段
      for (const key in formData) {
        if (Object.prototype.hasOwnProperty.call(formData, key)) {
          // 排除指定的列和复杂对象类型
          const value = formData[key];
          if (value && 
              typeof value !== 'object' && 
              !excludedColumns.includes(key)) {
            // 特殊处理指定字段
            if (specialFields.includes(key)) {
              specialValues.push(value);
            } else {
              formDataFields.push(value);
            }
          }
        }
      }
      
      // 连接formData中的字段值
      const specialFieldsString = specialValues.join('');
      const formDataString = formDataFields.join('-');
      
      // 处理professionalRows数据
      const professionalParts = professionalRows.map(row => {
        const rowValues = Object.entries(row)
          .map(([, val]) => val || '') // 保留所有值，空值转为空字符串
          .join(','); // 使用逗号分隔
        return `(${rowValues})`;
      }).join('-'); // 多行之间仍使用连字符分隔
      
     
      
      // 构建最终的导出文件名
      let exportname = prefix;
      if (formDataString) {
        exportname += `-${formDataString}`;
      }
      exportname += specialFieldsString;
      if (professionalParts) {
        exportname += `-${professionalParts}`;
      }
      
      return exportname;
    },
    
    // 导出志愿表
    exportToExcel() {
      // 定义不需要包含的列名
      const excludedColumns = ['expandedCell','same_rank_score','admission_rank'];
      // 特别处理的字段
      const specialFields = [];
      
      // 生成文件名
      const exportname = this.generateExportFileName('志愿表', this.formData || {}, this.professionalRows || [], excludedColumns, specialFields);
      
      // 导出数据
      this.exportData(this.wishList, exportname, exportname, '导出Excel成功');
    },
    
    // 创建进度弹窗
    showProgressDialog() {
      const overlay = document.createElement('div');
      overlay.id = 'export-progress-overlay';
      overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:10000;display:flex;justify-content:center;align-items:center;';

      const dialog = document.createElement('div');
      dialog.style.cssText = 'background:#fff;border-radius:12px;padding:30px 40px;min-width:420px;max-width:500px;box-shadow:0 8px 30px rgba(0,0,0,0.2);text-align:center;font-family:"Microsoft YaHei",sans-serif;';

      dialog.innerHTML = `
        <div style="font-size:20px;font-weight:bold;color:#303133;margin-bottom:24px;">
          <span style="display:inline-block;animation:export-spin 1.2s linear infinite;margin-right:8px;font-size:22px;">⏳</span>
          正在导出数据
        </div>
        <div style="margin-bottom:12px;width:100%;">
          <div style="width:100%;height:22px;background:#ebeef5;border-radius:11px;overflow:hidden;">
            <div class="export-progress-fill" style="width:0%;height:100%;background:linear-gradient(90deg,#409eff,#66b1ff);border-radius:11px;transition:width 0.4s ease;"></div>
          </div>
        </div>
        <div id="export-progress-text" style="color:#606266;font-size:15px;margin-top:8px;line-height:1.6;">正在准备数据...</div>
        <div id="export-progress-detail" style="color:#909399;font-size:13px;margin-top:6px;"></div>
      `;

      overlay.appendChild(dialog);
      document.body.appendChild(overlay);

      // 添加旋转动画
      if (!document.getElementById('export-progress-style')) {
        const style = document.createElement('style');
        style.id = 'export-progress-style';
        style.textContent = '@keyframes export-spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }';
        document.head.appendChild(style);
      }

      return overlay;
    },

    // 更新进度
    updateProgress(overlay, percent, text, detail) {
      if (!overlay || !overlay.parentNode) return;
      const fill = overlay.querySelector('.export-progress-fill');
      const textEl = overlay.querySelector('#export-progress-text');
      const detailEl = overlay.querySelector('#export-progress-detail');
      if (fill) fill.style.width = Math.min(percent, 100) + '%';
      if (textEl) textEl.textContent = text;
      if (detailEl) detailEl.textContent = detail || '';
    },

    // 关闭进度弹窗
    closeProgressDialog(overlay) {
      if (!overlay || !overlay.parentNode) return;
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.3s';
      setTimeout(() => {
        if (overlay.parentNode) overlay.remove();
      }, 350);
    },

    // 导出筛选表数据（带进度条）
    async exportFilteredData() {
      let progressOverlay = null;
      try {
        // 保存当前的分页数据、页码和筛选表数据
        const originalPageSize = this.pageSize;
        const originalCurrentPage = this.currentPage;
        const originalFilteredData = [...this.filteredData];
        this.pageSize = 'all';

        // 显示进度弹窗
        progressOverlay = this.showProgressDialog();
        this.updateProgress(progressOverlay, 0, '正在请求数据，获取数据总量...', '');

        // 分批获取，每批50所学校
        const batchSize = 50;
        const allResults = [];

        // 第一页请求：获取总数量 + 第一批数据
        this.updateProgress(progressOverlay, 3, '正在获取第 1 批数据...', '');
        const firstResponse = await axios.post('api/fetchCollegeAdmission/', {
          formData: this.formData,
          professionalRows: this.professionalRows,
          page: 1,
          page_size: batchSize
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        const totalSchools = firstResponse.data.count || 0;
        const totalPages = Math.max(1, Math.ceil(totalSchools / batchSize));

        // 处理第一页数据
        if (firstResponse.data.results && firstResponse.data.results.length > 0) {
          allResults.push(...firstResponse.data.results);
        }

        if (totalSchools === 0) {
          this.updateProgress(progressOverlay, 100, '没有符合条件的数据', '');
          this.$message.warning('没有找到符合条件的数据，无法导出');
          this.pageSize = originalPageSize;
          this.currentPage = originalCurrentPage;
          this.filteredData = originalFilteredData;
          this.isLoading = false;
          this.closeProgressDialog(progressOverlay);
          return;
        }

        // 逐页获取剩余数据
        for (let page = 2; page <= totalPages; page++) {
          const pct = Math.round(5 + ((page - 1) / totalPages) * 80);
          this.updateProgress(
            progressOverlay,
            pct,
            `正在获取第 ${page} / ${totalPages} 批数据...`,
            `已获取 ${allResults.length} 条记录`
          );

          const pageResponse = await axios.post('api/fetchCollegeAdmission/', {
            formData: this.formData,
            professionalRows: this.professionalRows,
            page: page,
            page_size: batchSize
          }, {
            withCredentials: true,
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-Csrftoken',
          });

          if (pageResponse.data.results && pageResponse.data.results.length > 0) {
            allResults.push(...pageResponse.data.results);
          }
        }

        // 生成Excel
        this.updateProgress(progressOverlay, 92, '正在生成 Excel 文件...', `共 ${allResults.length} 条记录`);

        // 定义不需要包含的列名和特殊字段
        const excludedColumns = ['expandedCell','same_rank_score','admission_rank'];
        const specialFields = [];
        const exportname = this.generateExportFileName('筛选表', this.formData, this.professionalRows, excludedColumns, specialFields);

        // 导出数据
        await new Promise(resolve => {
          this.exportData(allResults, exportname, exportname, '导出筛选表成功');
          // 给 UI 一点时间更新
          setTimeout(resolve, 100);
        });

        this.updateProgress(progressOverlay, 100, '导出完成！', '文件正在下载...');
        this.closeProgressDialog(progressOverlay);

        // 恢复原来的分页设置和数据
        this.pageSize = originalPageSize;
        this.currentPage = originalCurrentPage;
        this.filteredData = originalFilteredData;
        this.isLoading = false;

      } catch (error) {
        console.error('导出数据失败:', error);
        this.$message.error('导出筛选表失败，请稍后重试');
        this.isLoading = false;
        if (progressOverlay) this.closeProgressDialog(progressOverlay);
      }
    },
    
    // 导入志愿表
    importWishList() {
      // 显示导入弹窗
      this.showImportDialog = true;
    },

    // 拖拽文件处理
    handleDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
      e.dataTransfer.dropEffect = 'copy';
    },

    handleDragLeave(e) {
      e.preventDefault();
      e.stopPropagation();
    },

    handleDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        this.processImportedFile(files[0]);
        this.showImportDialog = false;
      }
    },

    // 点击选择文件
    handleFileSelect() {
      const input = this.$refs.fileInput;
      if (input && input.files && input.files[0]) {
        this.processImportedFile(input.files[0]);
        this.showImportDialog = false;
        input.value = '';
      }
    },

    // 处理导入的文件
    processImportedFile(file) {
      const self = this; // 保存this引用
      const reader = new FileReader();
      reader.onload = function(e) {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // 将Excel数据转换为JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          console.log('解析的Excel数据:', jsonData);
          console.log('当前wishList:', self.wishList);
          console.log('导入模式:', self.importMode);

          // 处理导入的数据，根据模式选择是覆盖还是添加
          // 过滤掉空数据（所有值为空的对象）
          const validData = jsonData.filter(row => {
            const values = Object.values(row);
            return values.some(v => v !== null && v !== undefined && v !== '');
          });
          console.log('过滤后的有效数据:', validData);

          if (validData.length > 0) {
            if (self.importMode === 'overwrite') {
              // 覆盖模式：直接赋值新数组
              const newData = validData.map(row => JSON.parse(JSON.stringify(row)));
              self.wishList.splice(0, self.wishList.length, ...newData);
              console.log('覆盖模式，新wishList长度:', self.wishList.length);
              self.$message.success(`成功覆盖导入 ${validData.length} 条志愿数据`);
            } else {
              // 添加模式：检查重复数据
              const existingData = self.wishList;
              const uniqueData = [];
              const duplicateRows = [];
              let duplicateCount = 0;

              validData.forEach(row => {
                // 检查是否与现有数据重复（比较学校名和专业名称）
                const isDuplicate = existingData.some(item => {
                  return item['学校名'] === row['学校名'] && item['专业名称'] === row['专业名称'];
                });

                if (isDuplicate) {
                  duplicateCount++;
                  duplicateRows.push(row);
                } else {
                  uniqueData.push(JSON.parse(JSON.stringify(row)));
                }
              });

              if (uniqueData.length > 0) {
                self.wishList.splice(self.wishList.length, 0, ...uniqueData);
                console.log('添加模式，wishList长度:', self.wishList.length);
                if (duplicateCount > 0) {
                  // 显示重复数据详情
                  const duplicateList = duplicateRows.map((row, index) => `${index + 1}. ${row['学校名']} - ${row['专业名称']}`).join('<br>');
                  self.$msgbox({
                    title: '重复数据提示',
                    message: self.$createElement('div', null, [
                      self.$createElement('p', null, `成功添加 ${uniqueData.length} 条志愿数据，以下 ${duplicateCount} 条数据已存在：`),
                      self.$createElement('div', { style: 'max-height: 200px; overflow-y: auto; margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 4px; line-height: 1.8;' }, [
                        self.$createElement('div', { domProps: { innerHTML: duplicateList } })
                      ])
                    ]),
                    confirmButtonText: '确定',
                    type: 'warning'
                  });
                } else {
                  self.$message.success(`成功添加 ${uniqueData.length} 条志愿数据`);
                }
              } else if (duplicateCount > 0) {
                // 显示所有重复数据
                const duplicateList = duplicateRows.map((row, index) => `${index + 1}. ${row['学校名']} - ${row['专业名称']}`).join('<br>');
                self.$msgbox({
                  title: '重复数据提示',
                  message: self.$createElement('div', null, [
                    self.$createElement('p', null, `所有数据都已存在，共 ${duplicateCount} 条：`),
                    self.$createElement('div', { style: 'max-height: 200px; overflow-y: auto; margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 4px; line-height: 1.8;' }, [
                      self.$createElement('div', { domProps: { innerHTML: duplicateList } })
                    ])
                  ]),
                  confirmButtonText: '确定',
                  type: 'warning'
                });
              }
            }
            // 强制表格更新
            self.$nextTick(() => {
              if (self.$refs.wishTable) {
                self.$refs.wishTable.doLayout();
              }
            });
          } else {
            self.$message.warning('导入的文件没有数据');
          }
        } catch (e) {
          console.error('处理导入文件出错:', e);
          self.$message.error('导入失败: ' + e.message);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }
}